let LegalArea = function () {
    let interaction_end = () => {
        $("#legal_area").hide();
        $("body").off("click.legal_area.btn", "#legal_area .btn");
    };
    this.interact = function () {
        return new Promise((resolve) => {
            let handlers = {
                close: () => {
                    interaction_end();
                    resolve();
                }
            };
            $("body").on("click.legal_area.btn", "#legal_area .btn", (event) => {
                handlers[$(event.currentTarget).data("method")]();
            });
            $("#legal_area").css("display", null);
        });
    };
};
export default new LegalArea();